import React from 'react';
import { useIntl } from 'react-intl-next';

import { Text } from '@atlaskit/primitives';

import { productivityInsightsI18n } from '../i18n';

export type TimeSavedMessageProps = {
	timeSaved: string;
};

export const TimeSavedMessage = ({ timeSaved }: TimeSavedMessageProps) => {
	const { formatMessage } = useIntl();
	const formattedMessage = formatMessage(productivityInsightsI18n.productivityTimeSavedMessage, {
		timeSaved,
		b: (chunks: React.ReactNode[]) => <Text weight="bold">{chunks}</Text>,
	});

	return (
		<>
			<Text>{formattedMessage}</Text>
		</>
	);
};
